import { useMediaQuery, useTheme } from '@mui/material';

/** Strip MUI breakpoint helper prefix for `window.matchMedia`. */
export function toMatchMediaQuery(query: string): string {
  return query.replace(/^@media\s*/u, '');
}

/** Synchronous viewport check — use for first-paint mobile routing decisions. */
export function readMobileLayoutMatch(query: string): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return false;
  }
  return window.matchMedia(toMatchMediaQuery(query)).matches;
}

/** True on phone / narrow tablet — mobile label-link flow and field mode shell. */
export function useMobileLayout(): boolean {
  const theme = useTheme();
  const query = theme.breakpoints.down('md');
  const defaultMatches = readMobileLayoutMatch(query);
  return useMediaQuery(query, { noSsr: true, defaultMatches });
}
